<template>
  <path pid="0" d="M12.55 2.11l-10 5a1 1 0 000 1.78l10 5a1 1 0 00.9 0l10-5a1 1 0 000-1.78l-10-5a1 1 0 00-.9 0zm.45 9.77L5.24 8 13 4.12 20.76 8z"/><path pid="1" d="M2.55 13.89l10 5a1 1 0 00.9 0l10-5a1 1 0 10-.9-1.78L13 16.88l-9.55-4.77a1 1 0 00-.9 1.78z"/><path pid="2" d="M2.55 18.89l10 5a1 1 0 00.9 0l10-5a1 1 0 10-.9-1.78L13 21.88l-9.55-4.77a1 1 0 00-.9 1.78z"/>
</template>
